<template>
	<div>
		<div style="margin-bottom: 18px;margin-top: 18px;">
			<label style="color: #333333;margin-left: 20px;">名称：</label>
			<el-input v-model="name" placeholder="请输入名称" suffix-icon="el-icon-search" style="width: 200px;" size="small"
				@keyup.enter.native="getData"></el-input>

			<el-button type="primary" style="margin-left: 15px;" size="small" @click="getData">查询</el-button>
			<el-button type="success" style="margin-left: 15px;" size="small" @click="reset">重置</el-button>
			<el-button type="warning" style="margin-left: 15px;" size="small" @click="add">新增</el-button>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border
			highlight-current-row>
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="name" align="center" label="名称(中文)" width="180">
			</el-table-column>
			<el-table-column prop="nameEg" align="center" label="名称(英文)" width="180">
			</el-table-column>
			<el-table-column prop="content" align="center" label="详情(中文)">
			</el-table-column>
			<el-table-column prop="contentEg" align="center" label="详情(英文)">
			</el-table-column>

			<el-table-column prop="operate" align="center" label="操作" width="200">
				<template slot-scope="scope">
					<el-button type="success" size="small" @click="mod(scope.row,1)">编辑</el-button>
					<el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row)" style="margin-left: 10px;">
						<el-button type="danger" slot="reference" size="small">删除</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>

		<div style="align-content: center;text-align: center;margin: 20px;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				:page-sizes="[2, 5, 10, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible" width="50%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="100px">

				<el-form-item label="名称(中文)" prop="name">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.name"></el-input> -->
						<tinymce-editor v-model="form.name" :init="initEditor" />
					</el-col>
				</el-form-item>
				<el-form-item label="名称(英文)" prop="nameEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.nameEg"></el-input> -->
						<tinymce-editor v-model="form.nameEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="详情(中文)" prop="content">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.firstTitle" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.content" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="详情(英文)" prop="contentEg">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.firstTitleEg" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.contentEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="类型(中文)" prop="type">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<tinymce-editor v-model="form.type" :init="initEditor" />
						<!-- <el-input v-model="form.firstSubTitle" type="textarea" :rows="3"></el-input> -->
					</el-col>
				</el-form-item>


				<el-form-item label="类型(英文)" prop="typeEg">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20" style="border: 1px solid gray;">
						<tinymce-editor v-model="form.typeEg" :init="initEditor" />
						<!-- <el-input v-model="form.firstSubTitleEg" type="textarea" :rows="3"></el-input> -->
					</el-col>
				</el-form-item>

				<!-- <el-form-item label="下载地址" prop="name">
					<el-col :span="20" >
						<el-input v-model="form.url"></el-input>
					</el-col>
				</el-form-item> -->

				<el-form-item label="附件" prop="url">
					<el-col :span="20">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="true"
							:on-success="handleAvatarSuccess" :limit="1" :accept="'.doc, .docx, .xls,.xlsx,.pdf'"
							:file-list="fileList" :before-upload="beforeAvatarUpload" :on-exceed="handleExceed">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传word/excel/pdf文件且不超过5M</div>
						</el-upload>

					</el-col>
				</el-form-item>

			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	export default {
		name: "UserMange",
		components: {
			TinymceEditor
		},
		data() {
			return {
				options: [{
					value: '1',
					label: '行业应用'
				}, {
					value: '2',
					label: '产品'
				}],
				rules: {
					name: [{
						required: true,
						message: '请输入名字',
						trigger: 'blur'
					}]
				},
				tableData: [],
				pageSize: 10,
				page: 1,
				total: 0,
				name: "",
				type: "",
				centerDialogVisible: false,
				form: {
					id: "",
					name: "",
					nameEg: "",
					content: "",
					contentEg: "",
					type: "",
					typeEg: "",
					url: ""
				},
				btnText: "提 交",
				textTitle: "新增下载资源",
				isDis: false,
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				fileList: [],
				fileList1: [],
				imageUrl: '',
				imgType: 0,
				fullscreenLoading: false
			}
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},
		beforeMount() {
			// this.utils.Logger("1111111111111111");
			this.getData();
			// this.loadPost();
		},
		methods: {
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，请删除文件后重新选择`);
			},
			beforeAvatarUpload(file) {

				const validTypes = [
					'application/vnd.ms-excel', // .xls
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
					'application/msword', // .doc
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
					'application/pdf' // .pdf
				];

				if (!validTypes.includes(file.type)) {
					this.$message.error("只能上传 Excel、Word 或 PDF 文件");
					return false; // 返回 false 以阻止上传
				}
				const isLt20M = file.size / 1024 / 1024 < 5;


				if (!isLt20M) {
					this.$message.error('上传文件大小不能超过 5MB!');
				}
				return isLt20M;
			},
			handleAvatarSuccess(res, file) {
				// this.form.attachment = URL.createObjectURL(file.raw);
				// this.form.url = res.data.id;
				this.form.url = "https://image.sxsla.cn/files/" + res.data.name;
			},
			mod(row, type) {
				this.form = row;
				this.imgType = type;
				this.btnText = "保存";
				this.textTitle = '修改资源下载信息'
				this.centerDialogVisible = true;
				this.fileList = [{
					name: row.fileUrl,
					url: row.fileUrl
				}]
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			save() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (that.btnText == "提交") {
							this.utils.requestPost(this, "/resourceHomeList/add", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "创建成功");
							});
						} else {
							this.utils.requestPost(this, "/resourceHomeList/mod", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "修改成功");
							});
						}
					} else {
						that.utils.showMessage("error", "请输入正确的内容");
						return false;
					}
				});

			},
			add() {
				var that = this;
				this.btnText = "提交";
				this.textTitle = '添加资源下载信息'
				this.imgType = 1;
				this.form = {
					id: "",
					name: "",
					nameEg: "",
					content: "",
					contentEg: "",
					type: "",
					typeEg: "",
					url: ""
				};
				this.fileList = [];
				this.centerDialogVisible = true;
				this.$nextTick(() => {
					that.resetForm();
				})
			},
			reset() {
				this.name = "";
				this.type = "";
			},
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
			deleteRow(row) {
				var that = this;
				this.utils.requestPost(this, "/resourceHomeList/delete", row, function(res, total) {
					that.getData();
					that.utils.showMessage("success", "删除成功");
				});
			},
			getData() {
				var that = this;
				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.name,
						"type": this.type
					}
				};
				this.utils.requestPost(this, "/resourceHomeList/getDataList", params, function(res, total) {
					that.tableData = res;
					that.total = total;
				});
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
